import {Link, Typography} from '@mui/material'
import {Link as RouterLink} from 'react-router-dom'
import {Routing} from '@zel-labs/routing'
import {useMeetingContext} from '../meeting'
import {Trans} from 'react-i18next'


export function DiscBreadcrumb() {
  const {meeting} = useMeetingContext()
  if (meeting == null) {
    return null
  }
  return <Link component={RouterLink} to={Routing.disc(meeting.ref)}><Typography
    variant="body2"><Trans i18nKey="meeting.assessments.disc.title"/></Typography></Link>
}
